export default "__VITE_ASSET__a7348c24__"